module.exports = ".chart-container {\n  min-width: 300px;\n  max-width: 1170px;\n  overflow: hidden;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/datawarehousegraph/graphView.css
// module id = 512
// module chunks = 0